/* @flow */

import type { ConnectedBrand } from '../types'

export const getDefaultCurrency = (brand: ConnectedBrand) =>
  brand.settings.currency
